<mat-card class="note-card" [class]="customClass" [style.top.px]="top">
  <div class="content">
    <p class="header" [attr.dat-qa]="title">{{title}}</p>
    <div class="date-time-wrapper">
      <p class="date-time">{{currentDateTime() | date: 'MMMM dd, yyyy'}}</p>
      <p class="date-time time">{{currentDateTime() | date: 'hh:mm a'}}</p>
    </div>
    <mat-form-field class="text-area">
      <textarea class="card-text" data-qa="card-text-area" matInput placeholder="{{placeHolder}}"
                rows="{{textRows}}" [attr.maxlength]="textLength" 
                [class.error-field]="isRequired && isTouched() && !isValid()"
                [value]="value" (input)="onInputChange($event)">
      </textarea>
      @if ((textLength??0) > 0) {
        <mat-hint align="end">{{value.length || 0}}/{{textLength}}</mat-hint>
      }
      @if (isRequired && isTouched() && !isValid()) {
        <div class="error-message">
          <small>Field is required.</small>
        </div>
      }
    </mat-form-field>
    <div class="footer">
      <button class="secondary_materials_button xsmall_button" disableRipple="true" id="close-button" 
              mat-stroked-button [attr.data-qa]="noButton.toLowerCase()+'-button'" 
              (click)="onClose()">{{noButton}}</button>
      <button class="yes-button xsmall_button primary_materials_button" disableRipple="true" id="confirm-button"
              mat-stroked-button [attr.data-qa]="yesButton.toLowerCase()+'-button'" [disabled]="isRequired && !isValid()"
              (click)="onConfirm(value)">{{yesButton}}</button>
    </div>
  </div>
</mat-card>